"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DatePickerRange = exports.getMaxEndDate = exports.getMinEndDate = exports.getMaxStartDate = exports.getMinStartDate = void 0;

var _grey = _interopRequireDefault(require("@material-ui/core/colors/grey"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DatePicker = _interopRequireDefault(require("./DatePicker"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Container = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "DatePickerRange__Container"
})(["display:flex;align-items:flex-start;"]);

var Separator = /*#__PURE__*/_styledComponents["default"].span.withConfig({
  displayName: "DatePickerRange__Separator"
})(["width:1px;height:", ";margin-bottom:", ";margin-top:", ";background-color:", ";display:inline-block;"], function (_ref) {
  var typography = _ref.theme.typography;
  return typography.pxToRem(20);
}, function (_ref2) {
  var typography = _ref2.theme.typography;
  return typography.pxToRem(7);
}, function (_ref3) {
  var typography = _ref3.theme.typography;
  return typography.pxToRem(21);
}, _grey["default"]['400']);

var getMinStartDate = function getMinStartDate() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      endDate = _ref4.endDate,
      maxRange = _ref4.maxRange;

  return endDate && maxRange ? new Date(endDate.valueOf() - maxRange) : undefined;
};

exports.getMinStartDate = getMinStartDate;

var getMaxStartDate = function getMaxStartDate() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      endDate = _ref5.endDate,
      minRange = _ref5.minRange;

  return endDate ? new Date(endDate.valueOf() - minRange) : undefined;
};

exports.getMaxStartDate = getMaxStartDate;

var getMinEndDate = function getMinEndDate() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      minRange = _ref6.minRange,
      startDate = _ref6.startDate;

  return startDate ? new Date(startDate.valueOf() + minRange) : undefined;
};

exports.getMinEndDate = getMinEndDate;

var getMaxEndDate = function getMaxEndDate() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      maxRange = _ref7.maxRange,
      startDate = _ref7.startDate;

  return startDate && maxRange ? new Date(startDate.valueOf() + maxRange) : undefined;
};

exports.getMaxEndDate = getMaxEndDate;

var DatePickerRange = function DatePickerRange(_ref8) {
  var onChange = _ref8.onChange,
      startDateLabel = _ref8.startDateLabel,
      endDateLabel = _ref8.endDateLabel,
      minRange = _ref8.minRange,
      maxRange = _ref8.maxRange,
      startDateProps = _ref8.startDateProps,
      endDateProps = _ref8.endDateProps,
      rest = _objectWithoutProperties(_ref8, ["onChange", "startDateLabel", "endDateLabel", "minRange", "maxRange", "startDateProps", "endDateProps"]);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      startDate = _useState2[0],
      setStartDate = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      endDate = _useState4[0],
      setEndDate = _useState4[1];

  (0, _react.useEffect)(function () {
    return onChange({
      startDate: startDate,
      endDate: endDate
    });
  }, [startDate, endDate]);
  var minStartDate = (0, _react.useMemo)(function () {
    return getMinStartDate({
      maxRange: maxRange,
      endDate: endDate
    });
  }, [maxRange, endDate]);
  var maxStartDate = (0, _react.useMemo)(function () {
    return getMaxStartDate({
      minRange: minRange,
      endDate: endDate
    });
  }, [minRange, endDate]);
  var minEndDate = (0, _react.useMemo)(function () {
    return getMinEndDate({
      minRange: minRange,
      startDate: startDate
    });
  }, [minRange, startDate]);
  var maxEndDate = (0, _react.useMemo)(function () {
    return getMaxEndDate({
      maxRange: maxRange,
      startDate: startDate
    });
  }, [maxRange, startDate]);
  return _react["default"].createElement(Container, null, _react["default"].createElement(_DatePicker["default"], _extends({}, rest, startDateProps, {
    label: startDateLabel,
    onChange: setStartDate,
    minDate: minStartDate,
    maxDate: maxStartDate
  })), _react["default"].createElement(Separator, null), _react["default"].createElement(_DatePicker["default"], _extends({}, rest, endDateProps, {
    label: endDateLabel,
    onChange: setEndDate,
    minDate: minEndDate,
    maxDate: maxEndDate
  })));
};

exports.DatePickerRange = DatePickerRange;
DatePickerRange.defaultProps = {
  onChange: function onChange() {},
  minRange: 0,
  maxRange: 0
};
DatePickerRange.propTypes = {
  onChange: _propTypes["default"].func,
  startDateLabel: _propTypes["default"].string,
  endDateLabel: _propTypes["default"].string,
  minRange: _propTypes["default"].number,
  maxRange: _propTypes["default"].number,
  startDateProps: _propTypes["default"].object,
  endDateProps: _propTypes["default"].object
};
var _default = DatePickerRange;
exports["default"] = _default;